export interface Account {
	accountID: string;
	accountContactId: number;
	accountName: string;
	roles: string[];
	application: string;
	relationshipActive: boolean;
	commsToGo: number;
	friCode?: string;
	isDefault?: boolean;
	isApproved: boolean;
}

/**
 * True only when the account is approved. Defensive against a missing or malformed value from the
 * API: anything other than an explicit `true` is treated as not approved — fail-safe, since a
 * pending account renders a harmless read-only gate page while an incorrectly-approved account
 * would skip that gate entirely.
 */
export function isAccountApproved(
	account: Pick<Account, "isApproved"> | null | undefined
): boolean {
	return account?.isApproved === true;
}

/** True when approved and active — the single source of truth for "can this account be picked". */
export function isAccountSelectable(
	account: Pick<Account, "isApproved" | "relationshipActive"> | null | undefined
): boolean {
	return isAccountApproved(account) && account?.relationshipActive !== false;
}
